import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=b8bc9a3c&scoped=true&"
import script from "./CommonList.vue?vue&type=script&lang=js&"
export * from "./CommonList.vue?vue&type=script&lang=js&"
import style0 from "./CommonList.vue?vue&type=style&index=0&id=b8bc9a3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bc9a3c",
  null
  
)

export default component.exports